import { DataAccessFactory } from './DataAccessFactory'
import { Resource } from './dataAccess'

class ShareFactory extends DataAccessFactory {

    constructor() {
        super();

        this.server = 'share'

        this.initialize()
    }

    initialize() {
        const resources: Array<Resource> = [
            {
                name: 'PlacementDetails',
                url: 'shareIntegration/application/:applicationId/placement',
                actions: {
                    get: {
                        method: 'GET',
                        params: { applicationId: '@applicationId' },
                        transformResponse: this.trans.responseHandler(
                            this.trans.convertToDate(
                                'matchStartDate',
                                'matchEndDate'
                            )
                        )
                    }
                }
            },
            {
                name: 'PlacementLetter',
                url: 'shareIntegration/placementLetter',
                actions: {
                    signedURL: {
                        method: 'GET',
                        url: 'shareIntegration/placementLetter/signedURL'
                    }
                }
            },
            {
                name: 'InterestedHostFamiliesDetails',
                url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2',
                actions: {
                    get: {
                        url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/interestedHFProposal/:proposalId/request/:requestId/',
                        method: 'GET',
                        params: {
                            applicationId: '@applicationId', proposalId: '@proposalId', requestId: '@requestId'
                        },
                        transformResponse: this.trans.responseHandler(
                            this.trans.convertToDate(
                                'proposalStatusDate',
                                'members.dob'
                            )
                        )
                    },
                    getDefault: {
                        url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/interestedHFProposal/:hostFamilyId',
                        method: 'GET',
                        params: {
                            applicationId: '@applicationId', hostFamilyId: '@hostFamilyId'
                        },
                        transformResponse: this.trans.responseHandler(
                            this.trans.convertToDate(
                                'proposalStatusDate',
                                'members.dob'
                            )
                        )
                    },
                    query: {
                        method: 'GET',
                        params: { applicationId: '@applicationId' },
                        isArray: true,
                        transformResponse: this.trans.responseHandler(
                            this.trans.convertToDate(
                                'proposalStatusDate'
                            )
                        )
                    },
                    document: {
                        url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/document/:documentId',
                        method: 'GET',
                        params: {
                            applicationId: '@applicationId', documentId: '@documentId'
                        }
                    },
                    count: {
                        url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/count',
                        method: 'GET',
                        params: { applicationId: '@applicationId' }
                    },
                    limits: {
                        url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/limits',
                        method: 'GET',
                        params: { applicationId: '@applicationId' }
                    }
                }
            },
            {
                name: 'HostFamiliesResult',
                url: 'shareIntegration/application/:applicationId/hostFamilies',
                actions: {
                    query: {
                        method: 'POST',
                        params: {
                            applicationId: '@applicationId'
                        },
                        transformRequest: this.trans.convertCheckboxToArray('region')
                    },
                    like: {
                        url: 'shareIntegration/application/:applicationId/hostFamilies/:hostFamilyId/like',
                        method: 'POST',
                        params: {
                            applicationId: '@applicationId',
                            hostFamilyId: '@hostFamilyId'
                        },
                    },
                    bookmark: {
                        url: 'shareIntegration/application/:applicationId/hostFamilies/:hostFamilyId/bookmark',
                        method: 'POST',
                        params: {
                            applicationId: '@applicationId',
                            hostFamilyId: '@hostFamilyId'
                        },
                    },
                    dismiss: {
                        url: 'shareIntegration/application/:applicationId/hostFamilies/:hostFamilyId/dismiss',
                        method: 'POST',
                        params: {
                            applicationId: '@applicationId',
                            hostFamilyId: '@hostFamilyId'
                        },
                    }
                }
            },
            {
                name: 'PlacementPackDetails',
                url: 'shareIntegration/application/:applicationId/placement/:timeFrame',
            },
            {
                name: 'PlacementMatchesDetails',
                url: 'shareIntegration/application/:applicationId/placement/matches',
                actions: {
                    getMatches: {
                        method: 'GET',
                        params: { applicationId: '@applicationId' },
                        transformResponse: this.trans.responseHandler(
                            this.trans.convertToDate(
                                'matchStartDate',
                                'matchEndDate'
                            )
                        ),
                        isArray: true
                    }
                }
            },
            {
                name: 'DeclineInterestedHostFamilyReasons',
                url: 'shareIntegration/lookup/declineInterestedHFReasons',
                actions: {
                    query: {
                        method: 'GET',
                        params: { applicationId: '@applicationId' },
                        isArray: true
                    }
                }
            },
            {
                name: 'InterestedHostFamilyFeedback',
                url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/interestedHFProposal/:proposalId/request/:requestId/feedback',
                actions: {
                    save: {
                        method: 'POST',
                        params: {
                            applicationId: '@applicationId', proposalId: '@proposalId', requestId: '@requestId'
                        }
                    },
                    saveLast: {
                        method: 'POST',
                        url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/interestedHFProposal/feedback',
                        params: {
                            applicationId: '@applicationId'
                        }
                    }
                }
            },
            {
                name: 'InterestedHostFamilyDocuments',
                url: 'shareIntegration/application/:applicationId/interestedHostFamilies/v2/interestedHFProposal/:proposalId/request/:requestId/',
                actions: {
                    query: {
                        method: 'GET',
                        params: {
                            applicationId: '@applicationId', proposalId: '@proposalId', requestId: '@requestId'
                        }
                    }
                }
            },
            {
                name: 'ExternalResource',
                url: 'shareIntegration/external',
                actions: {
                    flightPaymentURL: {
                        method: 'GET',
                        url: 'shareIntegration/external/:applicationId/flightPaymentURL',
                        params: { applicationId: '@applicationId' },
                    },
                    preArrivalInsuranceURL: {
                        method: 'GET',
                        url: 'shareIntegration/external/:applicationId/preArrivalInsuranceURL',
                        params: { applicationId: '@applicationId' },
                    }
                }
            },
            {
                name: 'ExtensionInsuranceToken',
                url: 'shareIntegration/getInsurancePaymentToken'
            },
        ]

        this.process(resources)
    }
}

new ShareFactory()
